/** @format */

import styled, { css } from "styled-components";
import arrow from "../../../assets/rawSvgs/arrow.svg";

interface SelectorProps {
  value?: string;
  placeholder?: string;
}

export const Selector = styled.select<SelectorProps>`
  display: flex;
  align-items: center;
  flex: 1;
  border: 0;
  appearance: none;
  background-image: url("${arrow}");
  background-repeat: no-repeat;
  background-position: calc(100% - 1rem);
  background-size: 0.9rem;
  cursor: pointer !important;
  color: ${({ theme, value, placeholder }) => 
    value === placeholder ? '#8c8884' : theme.colors.black.black100};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 2rem; /* Ensure text doesn't overlap with the arrow */

 

  &:focus {
    outline: 0;
  }
  &:focus-visible {
    outline: 0;
    --border-color: var(--action-primary-default) !important;
  }

  option {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
